<template>
    <div class="task">
        <Head-view :showStyle="7"></Head-view>
        <div class="main">
            <div class="breadcrumb">故障管理</div>
            <div class="nav">
                <div class="searchLeft">
                    <div class="fontName">上报者</div>
                    <div class="searchInp">
                        <el-select
                            v-model="staffId"
                            clearable
                            placeholder="请选择"
                        >
                            <el-option
                                v-for="item in staffArr"
                                :key="item.staffId"
                                :label="item.name"
                                :value="item.staffId"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div class="departName">进度</div>
                    <div class="searchInp">
                        <el-select
                            v-model="statusNum"
                            clearable
                            placeholder="请选择"
                        >
                            <el-option
                                v-for="item in statusArr"
                                :key="item.number"
                                :label="item.status"
                                :value="item.number"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div class="departName">点位</div>
                    <div class="searchInp">
                        <el-select
                            v-model="placeId"
                            clearable
                            placeholder="请选择"
                        >
                            <el-option
                                v-for="item in placeArr"
                                :key="item.placeId"
                                :label="item.name"
                                :value="item.placeId"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div class="searchBtn" @click="searchBtn()">搜索</div>
                </div>
            </div>

            <div class="showTba">
                <div class="bodyTable">
                    <el-table
                        :data="tableData"
                        style="width: 100%; max-height: 489px"
                        height="489px"
                        v-loading="loading"
                        stripe
                    >
                        <el-table-column
                            prop="reportTime"
                            label="上报时间"
                            width="160"
                        >
                        </el-table-column>
                        <el-table-column label="上报者" width="130">
                            <template slot-scope="scope">
                                <div class="staffName">
                                    {{ scope.row.staffName }} <br />
                                    <span v-if="scope.row.staffDept"> ({{ scope.row.staffDept }}) </span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="相关点位的图片" width="150">
                            <template slot-scope="scope">
                                <div class="headImg">
                                    <img v-if="scope.row.placePicture" :src="scope.row.placePicture" alt="" />
                                    <img v-if="!scope.row.placePicture" src="../../assets/placeDefaultImg.png" alt="" />
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="taskName"
                            label="相关任务的名称"
                            width="180"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="routeName"
                            label="相关路线的名称"
                            width="200"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="placeName"
                            label="点位名称"
                            width="180"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="details"
                            label="故障详情"
                            width="200"
                        >
                        </el-table-column>
                        <el-table-column label="处理进度" width="160">
                            <template slot-scope="scope">
                                <div
                                    :class="[
                                        scope.row.status == 1
                                            ? 'colorYellow'
                                            : '',
                                        scope.row.status == 2
                                            ? 'colorRed'
                                            : '',
                                        scope.row.status == 3
                                            ? 'colorGreen'
                                            : '',
                                    ]"
                                >
                                    {{ scope.row.stutasObj }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="250">
                            <template slot-scope="scope">
                                <el-button
                                    @click="handleEide(scope.$index, scope.row)"
                                    type="text"
                                    size="small"
                                    class="colorBulr"
                                    >详情</el-button
                                >
                                <el-button
                                    type="text"
                                    size="small"
                                    :class="[
                                        scope.row.status == 1
                                            ? 'colorBulr'
                                            : 'colorBlack',
                                    ]"
                                    @click="
                                        handleConfirm(scope.$index, scope.row)
                                    "
                                    >确认</el-button
                                >
                                <el-button
                                    type="text"
                                    size="small"
                                    :class="[
                                        scope.row.status == 3
                                            ? 'colorBlack'
                                            : 'colorBulr',
                                    ]"
                                    @click="
                                        handleChange(scope.$index, scope.row)
                                    "
                                    >标记为已处理</el-button
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageination">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageObj.currentPage"
                        :page-sizes="pageObj.pageSizeArr"
                        :page-size="pageObj.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="pageObj.total"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>

        <el-dialog
            title="标记为已处理"
            :visible.sync="dialogVisible"
            width="30%"
        >
            <div class="changePassword">
                <div class="from">
                    <div class="title">凭证：</div>
                    <div class="fromInp">
                        <div
                            class="addImg addHeadImg"
                            v-for="(item, key) in imgArr"
                            :key="key"
                        >
                            <img :src="item" alt="" />
                            <div class="delHeadImg" @click="delHeadImg(key)">
                                <i class="el-icon-delete"></i>
                            </div>
                        </div>
                        <div
                            class="addHeadImg borderClass"
                            v-if="imgArr.length <= 10"
                        >
                            <input
                                type="file"
                                name="file"
                                ref="headImgRef"
                                accept="image/*,.jpg,.png,.git,.webp,.svg,"
                                multiple="multiple"
                                @change="uploadHeadImg"
                            />
                        </div>
                    </div>
                </div>
                <div class="from">
                    <div class="title">备注：</div>
                    <div class="fromInp">
                        <el-input
                            type="textarea"
                            v-model="remarks"
                            placeholder="请输入"
                            resize="none"
                            :autosize="{ minRows: 6, maxRows: 6 }"
                        ></el-input>
                    </div>
                </div>
            </div>
            <div class="towImgFont"></div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmUp()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import HeadView from "@/components/HeadView";
export default {
    name: "task",
    data() {
        return {
            placeId: "",
            placeArr: [],

            staffId: "",
            staffArr: [],

            statusNum: "",
            statusArr: [
                //1-审批中 2-待处理 3-已处理
                {
                    status: "审批中",
                    number: "1",
                },
                {
                    status: "待处理",
                    number: "2",
                },
                {
                    status: "已处理",
                    number: "3",
                },
            ],

            tableData: [],

            insId: "",

            pageObj: {
                currentPage: 1,
                pageSizeArr: [10, 40, 100, 400],
                pageSize: 10,
                total: 0,
            },

            loading: false,
            dialogVisible: false,

            remarks: "",
            imgArr: [],
            fileImgArr: [],
            handleChangeObj: {},
        };
    },

    components: {
        HeadView,
    },

    mounted() {
        this.insId = Number(localStorage.getItem("insId"));
        // this.userId = localStorage
        this.faultInfo();

        this.rolePersonnelInfo(); //人员
        this.getAllPlace(); //点位
    },

    methods: {
        faultInfo() {
            this.loading = true;
            let data = {
                token: this.getCookie(),
                insId: this.insId,
                page: this.pageObj.currentPage,
                limit: this.pageObj.pageSize,
                placeId: this.placeId == "" ? -1 : this.placeId,
                staffId: this.staffId == "" ? -1 : this.staffId,
                status: this.statusNum == "" ? -1 : this.statusNum,
            };
            this.request
                .post(this.baseUrl + "fault/getFaultList", data)
                .then((res) => {
                    if (res.code == 0 && res.data.totalCount >= 0) {
                        let data = [];

                        res.data.list.forEach((item, key) => {
                            data.push(item);
                            data[key]["stutasObj"] = this.handleStatus(
                                item.status
                            );
                            data[key]["taskName"] = data[key]["taskName"]
                                ? data[key]["taskName"]
                                : "-";
                            data[key]["placeName"] = data[key]["placeName"] ? data[key]["placeName"] : "-"
                            data[key]["routeName"] = data[key]["routeName"]
                                ? data[key]["routeName"]
                                : "-";
                            if (item.details.length > 35) {
                                data[key]["details"] = item.details.substr(0, 35) + '...'
                            }
                        });
                        this.tableData = data;
                        this.pageObj.total = res.data.totalCount;
                    } else {
                        this.$message({
                            type: "warning",
                            message: res.msg,
                        });
                    }
                    this.loading = false;
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message({
                        type: "warning",
                        message: "获取点位列表失败",
                    });
                });
        },

        rolePersonnelInfo() {
            let data = {
                insId: this.insId,
                token: this.getCookie(),
            };
            this.request
                .post(this.baseUrl + "institution/getAllStaffList", data)
                .then((res) => {
                    if (res.code == 0) {
                        this.staffArr = res.data;
                    } else {
                        this.$message({
                            type: "warning",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.$message({
                        type: "error",
                        message: "获取人员失败",
                    });
                });
        },

        getAllPlace() {
            //获取点位管理
            let data = {
                token: this.getCookie(),
                insId: this.insId,
                keyword: "",
            };
            this.request
                .post(this.baseUrl + "place/getAllPlaceList", data)
                .then((res) => {
                    if (res.code == 0) {
                        this.placeArr = res.data;
                    } else {
                        this.$message({
                            type: "waring",
                            message: res.msg,
                        });
                    }
                });
        },

        searchBtn() {
            this.faultInfo();
        },

        handleConfirm(index, row) {
            if (row.status != 1) return;
            this.$confirm("确认进入待处理流程？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let data = {
                        token: this.getCookie(),
                        faultId: row.faultId,
                        staffId: localStorage.getItem("staffId"),
                        status: 2,
                        remarks: "确认故障，进入待处理流程",
                        picList: [],
                    };
                    this.request
                        .post(this.baseUrl + "fault/addFaultHandleRecord", data)
                        .then((res) => {
                            if (res.code == 0 && res.data.result) {
                                this.$message({
                                    type: "success",
                                    message: "修改成功",
                                });
                                this.faultInfo();
                            } else {
                                this.$message({
                                    type: "warning",
                                    message: res.msg,
                                });
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                            this.$message({
                                type: "error",
                                message: "出错了，修改失败",
                            });
                        });
                })
                .catch(() => {});
        },

        handleChange(index, row) {
            if (row.status == 3) return;
            this.dialogVisible = true;
            this.handleChangeObj = row;
        },

        uploadHeadImg(e) {
            let _this = this;
            let fileArr = e.target.files;
            let num = 1;
            for (let x in fileArr) {
                if (x == "length") return;
                if (num > 10) {
                    return this.$message({
                        type: "warning",
                        message: "最多上传10张图片",
                    });
                }
                this.fileImgArr.push(fileArr[x])
                let imgData = new FileReader();
                imgData.readAsDataURL(fileArr[x]);
                imgData.onload = function (ev) {
                    _this.imgArr.push(this.result);
                    num++;
                };
            }
        },

        delHeadImg(key) {
            this.imgArr.splice(key, 1);
            this.fileImgArr.splice(key, 1);
        },

        confirmUp() {
            
            let urlArr = [];
            const loading = this.$loading({
                lock: true,
                text: "",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            if (this.fileImgArr.length > 0) {
                this.fileImgArr.forEach((item) => {
                    let formData = new FormData()
                    formData.append('file', item)
                    formData.append('token', this.getCookie())

                    this.request
                        .post(this.commUrl + "uploadFile", formData)
                        .then((res) => {
                            if (res.code == 0) {
                                urlArr.push(res.data.url);
                                if (urlArr.length == this.fileImgArr.length) {
                                    this.upDataFault(urlArr, loading);
                                }
                            } else {
                                loading.close();
                                this.$message({
                                    type: "warning",
                                    message: res.msg,
                                });
                            }
                        })
                        .catch((err) => {
                            loading.close();
                            this.$message({
                                type: "error",
                                message: "出错了，上传图片失败",
                            });
                        });
                });
            } else {
                this.upDataFault(urlArr, loading)
            }
        },

        upDataFault(urlArr, loading) {
            let remarks = '标记已处理：<'+ (this.remarks ? this.remarks : '暂无备注') +'>'
            let data = {
                token: this.getCookie(),
                faultId: this.handleChangeObj.faultId,
                staffId: localStorage.getItem("staffId"),
                status: 3,
                remarks: remarks,
                picList: urlArr,
            };
            this.request
                .post(this.baseUrl + "fault/addFaultHandleRecord", data)
                .then((res) => {
                    if (res.code == 0 && res.data.result) {
                        this.faultInfo();
                        this.$message({
                            type: "success",
                            message: "修改成功",
                        });
                    } else {
                        this.$message({
                            type: "warning",
                            message: res.msg,
                        });
                    }
                    this.dialogVisible = false
                    loading.close();
                })
                .catch((err) => {
                    loading.close();
                    this.$message({
                        type: "error",
                        message: "出错了，修改失败",
                    });
                });
        },

        handleSizeChange(val) {
            this.pageObj.pageSize = val;
            this.faultInfo();
        },
        handleCurrentChange(val) {
            this.pageObj.currentPage = val;
            this.faultInfo();
        },
        handleEide(index, row) {
            this.$router.push({
                path: "/fault/faultMsg",
                query: {
                    id: row.faultId,
                },
            });
        },

        handleStatus(key) {
            switch (key) {
                case 1:
                    return "审批中";
                case 2:
                    return "待处理";
                case 3:
                    return "已处理";
            }
        },
    },
};
</script>

<style lang="less" scoped>
.task {
    height: 100vh;

    .main {
        margin-right: 24px;
        padding: 72px 0 0 227px;
        .breadcrumb {
            margin-left: 7px;
            color: rgba(84, 85, 86, 1);
            font-size: 12px;
            line-height: 20px;
            font-weight: 400;
        }
        .nav {
            margin-top: 24px;
            margin-left: 7px;
            height: 68px;
            background: rgba(255, 255, 255, 1);
            border-radius: 4px;
            .searchLeft {
                float: left;
                margin: 12px 0 0 20px;
                display: flex;
                flex-direction: row;
                height: 40px;
                background: rgba(255, 255, 255, 1);
                border-radius: 4px;
                .fontName {
                    width: 72px;
                    color: rgba(48, 49, 51, 1);
                    font-size: 14px;
                    line-height: 14px;
                    font-weight: 400;
                    line-height: 40px;
                }
                .searchInp {
                    width: 211px;
                }
                .departName {
                    width: 64px;
                    color: rgba(48, 49, 51, 1);
                    font-size: 14px;
                    line-height: 14px;
                    font-weight: 400;
                    text-align: center;
                    line-height: 40px;
                }
                .searchBtn {
                    margin-left: 20px;
                    width: 68px;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    background: rgba(4, 134, 254, 1);
                    border-radius: 4px;
                    color: #fff;
                    font-size: 14px;
                    font-weight: 500;
                    cursor: pointer;
                }
            }

            .institutionAddBtn {
                margin: 14px 17px 0 0;
                float: right;
                width: 95px;
                height: 40px;
                text-align: center;
                line-height: 40px;
                background: rgba(4, 134, 254, 1);
                border-radius: 4px;
                color: rgba(255, 255, 255, 1);
                font-size: 14px;
                font-weight: 500;
                cursor: pointer;
            }
        }
        .showTba {
            margin-top: 24px;
            margin-right: 7px;
            padding: 16px 17px 0 31px;
            height: 618px;
            background: #fff;
            .bodyTable {
                width: 100%;
                height: 500px;
                overflow: hidden;
                overflow-y: auto;
                .headImg {
                    width: 48px;
                    height: 48px;
                    overflow: hidden;
                    img {
                        width: 100%;
                    }
                }

                .staffName {
                    span {
                        font-size: 14px;
                        font-weight: 500;
                        color: rgba(166, 166, 166, 1);
                        text-align: left;
                    }
                }

                .colorBlack {
                    color: rgba(166, 166, 166, 1);
                }

                .colorBulr {
                    color: rgba(25, 137, 250, 1);
                }

                .colorGreen {
                    color: rgba(33, 199, 159, 1);
                }

                .colorYellow {
                    color: rgba(255, 195, 0, 1);
                }
            }
            .pageination {
                margin-top: 69px;
                text-align: right;
            }
        }

        .colorRed {
            color: rgba(255, 87, 51, 1);
        }

        .colorBulr {
            color: rgba(25, 137, 250, 1);
        }
    }

    .changePassword {
        width: 406px;
        .userNum {
            margin-bottom: 16px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(84, 85, 86, 1);
        }

        .from {
            margin-top: 20px;
            display: flex;
            flex-direction: row;
            .title {
                width: 64px;
                font-size: 14px;
                font-weight: 400;
                color: rgba(84, 85, 86, 1);
                line-height: 40px;
            }

            .fromInp {
                width: 326px;
                .borderClass {
                    border: 1px solid rgba(216, 220, 230, 1);
                }
                .addHeadImg {
                    margin-right: 5px;
                    margin-bottom: 5px;
                    float: left;
                    position: relative;
                    width: 60px;
                    height: 60px;
                    background: url("../../assets/addBtn.png") no-repeat center
                        center;
                    overflow: hidden;
                    input {
                        opacity: 0;
                        width: 100%;
                        height: 100%;
                    }
                    img {
                        width: 100%;
                    }
                    .delHeadImg {
                        display: none;
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background-color: rgba(0, 0, 0, 0.5);
                        color: #fff;
                        text-align: center;
                        line-height: 60px;
                    }
                }

                .addHeadImg:hover .delHeadImg {
                    display: block;
                }
            }

            /deep/ .el-textarea__inner {
                width: 100%;
            }
        }
    }
}
</style>